import React from 'react';
import '../styles/reset.css'
import '../styles/Header.css'

function Header() {
    return (
        <div className="header-container">
            <h2 className="header-text">Welcome and check out the Picture of the Day below!</h2>
        </div>
    );
}

export default Header;